// extracted by mini-css-extract-plugin
export var formContainer = "_dg-0";
export var message = "_dg-1";